export default __webpack_public_path__ + "static/RamanSharma-91056be68ae151ca0a15bf4bc1b71e79.png";